import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GrantableRoleResponse } from '@/repositories/generated';
import { ERole } from '@/types';

const response: GrantableRoleResponse[] = [
  {
    code: ERole.SYSTEM_MANAGER,
    name: 'システム管理者',
  },
  {
    code: ERole.SYSTEM_STAFF,
    name: 'システム担当者',
  },
  {
    code: ERole.TENANT_MANAGER,
    name: 'テナント管理者',
  },
  {
    code: ERole.TENANT_STAFF,
    name: 'テナント担当者',
  },
  {
    code: ERole.ACQUIRER_MANAGER,
    name: 'アクワイアラ管理者',
  },
  {
    code: ERole.ACQUIRER_STAFF,
    name: 'アクワイアラ担当者',
  },
  {
    code: ERole.VALUE_ISSUER_MANAGER,
    name: 'バリューイシュア管理者',
  },
  {
    code: ERole.VALUE_ISSUER_STAFF,
    name: 'バリューイシュア担当者',
  },
  {
    code: ERole.WALLET_SERVICE_MANAGER,
    name: 'ウォレットサービス管理者',
  },
  {
    code: ERole.WALLET_SERVICE_STAFF,
    name: 'ウォレットサービス担当者',
  },
  {
    code: ERole.COMPANY_MANAGER,
    name: '企業管理者',
  },
  {
    code: ERole.COMPANY_STAFF,
    name: '企業担当者',
  },
  {
    code: ERole.SHOP_MANAGER,
    name: '店舗管理者',
  },
  {
    code: ERole.SHOP_STAFF,
    name: '店舗担当者',
  },
  {
    code: ERole.GIFT_ISSUER_MANAGER,
    name: '商品券管理者',
  },
  {
    code: ERole.GIFT_ISSUER_STAFF,
    name: '商品券担当者',
  },
];

export const loginUserGrantableRole = http.get(
  createMockEndpoint('/login_user/grantable_role'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
